<template>
  <draggable class="status-route-list-item" ghost-class="dropzone-ghost" draggable=".item" :list="list1" group="jobs"
    :id="`status/${status.Id}`" @change="log">
    <RouteListItem :node="{
      name: node.name,
      children: substatuses,
      meta: {
        displayName: status.Name,
        icon: statusicon(status.Id),
        count: status.Count,
        params: {
          filter: `status-${status.Id}-0`,
        }
      }
    }" :openfunc="() => { return ($route.name == node.name && $route.params.statusId == status.Id) }">

      <template slot="icon" slot-scope="{ icontext }">
        <v-badge dot offset-y="5" bottom :color="onlyIconMode && status.Count > 0 ? 'primary' : 'transparent'">
          <v-badge dot offset-y="7" bottom :color="onlyIconMode && subsatusCount > 0 ? '#4397E8' : 'transparent'"
            class="liftup10">
            <v-icon size="22" class="node-icon">
              <slot name="icon-text">{{ icontext }}</slot>
            </v-icon>
          </v-badge>
        </v-badge>
      </template>

      <template slot="count">
        <CardBadge :color="'primary'" :count="status.Count" :index="0">
        </CardBadge>
        <CardBadge :color="'#4397E8'" :count="subsatusCount" :index="1">
        </CardBadge>
      </template>

      <template slot="children">
        <draggable v-for="substatus in substatuses" :key="substatus.Id" class="sub-status-route-list-item"
          ghost-class="dropzone-ghost" draggable=".item" :list="list1" group="jobs"
          :id="`status/${status.Id}/substatus/${substatus.Id}`" @change="log">
          <RouteListItem :node="{
            name: node.name,
            meta: {
              displayName: substatus.Name,
              icon: statusicon(status.Id),
              count: substatus.Count,
              params: { filter: `status-${status.Id}-${substatus.Id}`, }
            }
          }">
          </RouteListItem>
        </draggable>
      </template>
    </RouteListItem>
  </draggable>
</template>


<script>
import CardBadge from "@/components/Buttons/CardBadge.vue";
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import draggable from "vuedraggable";

export default {
  name: "RouteListItem_Status",
  props: {
    status: Object,
    node: Object,
  },
  components: {
    RouteListItem,
    CardBadge,
    draggable,
  },

  data() {
    return {
      list1: [],
    };
  },

  mounted() { },

  methods: {
    log(e) {
      console.log(this.status, e);
    },
  },

  computed: {
    onlyIconMode() {
      if (!this.isPadBool) {
        return !this.$store.getters["navstore/Extended"];
      } else {
        return false;
      }
    },

    substatuses() {
      if (this.status) {
        var list = this.$store.getters["LookUpStore/JobSubStatusListByParent"](this.status.Id);
        return list.filter(x => x.IsActive);
      } else {
        return [];
      }
    },

    subsatusCount() {
      var count = 0;
      this.substatuses.forEach((x) => {
        count += x.Count;
      });
      return count;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.liftup10 {
  z-index: 10;
}
</style>

<style lang="scss">
.status-route-list-item,
.sub-status-route-list-item {
  position: relative;
}

.dropzone-ghost {
  border: 2px dashed var(--v-tertiary-base) !important;
  background-color: rgba($color: #af7742, $alpha: 0.1);
  position: absolute;
  z-index: 200;
  top: 0;
  bottom: 0;
  height: 40px;
  width: 100%;
}

.status-route-list-item .sumo {
  display: none !important;
}

@media only screen and (max-width: 1400px) and (min-width: 1000px) {
  .dropzone-ghost {
    height: 36px;
  }
}
</style>